(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-albero-famiglia"]) return;
  try {
    
  function initFamilyTrees(root=document){
    root.querySelectorAll('.es-tree__form').forEach(form=>{
      if(form.dataset.initialized)return;
      form.dataset.initialized='true';
      const variants=form.querySelector('[data-tree-variant]');
      const balls=[...form.querySelectorAll('[data-tree-ball]')];
      const button=form.querySelector('[data-tree-submit]');
      const message=form.querySelector('[data-tree-validation]').textContent;
      const validateBall=ball=>{
        const name=ball.querySelector('[data-tree-name]');
        name.setCustomValidity(!ball.disabled&&!name.value.trim()?message:'');
      };
      const sync=()=>{
        const option=variants.selectedOptions[0];
        const count=Number(option?.dataset.count||1);
        balls.forEach(ball=>{const active=Number(ball.dataset.treeBall)<=count;ball.hidden=!active;ball.disabled=!active;validateBall(ball);});
        const available=option?.dataset.available==='true';
        button.disabled=!available;
        button.textContent=available?button.dataset.label:button.dataset.soldOut;
      };
      variants.addEventListener('change',sync);
      balls.forEach(ball=>ball.addEventListener('input',()=>validateBall(ball)));
      form.addEventListener('submit',event=>{balls.forEach(validateBall);if(!form.reportValidity())event.preventDefault();});
      sync();
    });
  }
  initFamilyTrees();
  document.addEventListener('shopify:section:load',event=>initFamilyTrees(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
